export const GET_ROLE_SUCCEED = "role/get/succeed";
export const GET_ROLE_REQUEST = "role/get/request";
export const GET_ROLE_FAILED = "role/get/failed";

export const CREATE_ROLE_REQUEST = "role/create/request";
export const CREATE_ROLE_SUCCEED = "role/create/succeed";
export const CREATE_ROLE_FAILED = "role/create/failed";

export const DELETE_ROLE_REQUEST = "role/delete/request";
export const DELETE_ROLE_SUCCEED = "role/delete/succeed";
export const DELETE_ROLE_FAILED = "role/delete/failed";

export const GET_BY_ID_ROLE_REQUEST = "role/getid/request";
export const GET_BY_ID_ROLE_SUCCEED = "role/getid/succeed";
export const GET_BY_ID_ROLE_FAILED = "role/getid/failed";

export const UPDATE_ROLE_REQUEST = "role/update/request";
export const UPDATE_ROLE_SUCCEED = "role/update/succeed";
export const UPDATE_ROLE_FAILED = "role/update/failed";
